module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_footer_image_02-fcfe579b63e78d6ca11c21847fad69a9.jpg";